export default function BrowserToolsSection() {
  return (
    <section className="py-20 px-4 border-t border-gray-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center">
          Why Browser-Based Tools Matter
        </h2>
        <div className="mt-8 space-y-5 text-gray-600 leading-relaxed text-base sm:text-lg">
          <p>
            Traditional desktop software and mobile apps often require installation, accounts, and
            background updates. Browser-based tools run where you already work — in Chrome, Firefox,
            Safari, or Edge — with no admin rights and no app store approval delays.
          </p>
          <p>
            For privacy-sensitive tasks like building a resume, generating a QR code, or converting
            clothing sizes while shopping abroad, local-first browser processing means your files and
            measurements are not automatically uploaded to a cloud you did not choose. You export when
            ready and keep control of where data goes next.
          </p>
          <p>
            PixelUtility splits architecture intentionally: <strong className="text-gray-900">pixelutility.com</strong> is
            the content and SEO hub with guides, FAQs, and blog articles. Each live tool runs on its own
            subdomain (resume, QR, size converter) for performance and clear separation. Landing pages here
            are full informational pages — not thin redirect doorways — so you get real value before opening
            the interactive utility.
          </p>
          <p>
            Performance matters for SEO and AdSense quality reviews. Lightweight React pages, clear
            headings, structured data, and internal links between tools, blog posts, privacy, and support
            help search engines understand the site as a publisher platform, not an empty shell around ads.
          </p>
        </div>
      </div>
    </section>
  );
}
